import { HiExternalLink } from "react-icons/hi";
import { PRODUCT_AMAZON_LINKS } from "../../../utils/marketplaceConstants";
import { useAppSelector } from "../../../redux/hooks";
import { useTranslation } from "react-i18next";

interface Props {
  asin?: string;
}

const ExternalProductLink = ({ asin }: Props) => {
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const channel = useAppSelector((state) => state.channel);
  const { t } = useTranslation(["merchandising"]);
  let productLink;
  if (channel.currentChannel === "amazon") {
    productLink = PRODUCT_AMAZON_LINKS[marketPlace.marketPlace];
    if (productLink) {
      productLink = `${productLink}${asin}`;
    }
  }
  if (channel.currentChannel === "walmart") {
    productLink = `https://www.walmart.com/ip/${asin}`;
  }
  return productLink ?
      <a
        href={productLink}
        target="_blank"
        rel="noopener noreferrer"
        title={t(($) => $.merchandising["View on Amazon"])}
      >
        <HiExternalLink />
      </a>
    : null;
};

export default ExternalProductLink;
